import { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import img1 from "../../Assets/images/contact-us1.png";
import img2 from "../../Assets/images/contact-us2.png";
import './contactUs.css';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';

const initialValues = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  city: '',
  country: '',
  subject: '',
  message: '',
};

const emailRegex =
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const phoneDigits = (v) => v.replace(/[^\d+]/g, '');

const ContactUs = () => {
  const { t } = useTranslation();

  const [values, setValues] = useState(initialValues);
  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const requiredMsg = t("contactUs.validation.required", { defaultValue: t("contactUs.validation.subject") || "This field is required" });
  const emailMsg = t("contactUs.validation.email", { defaultValue: "Please enter a valid email address." });
  const phoneMsg = t("contactUs.validation.phone", { defaultValue: "Please enter a valid phone number." });
  const subjectMsg = t("contactUs.validation.subject", { defaultValue: "Please add a subject." });

  const validate = (v) => {
    const e = {};

    // required fields
    ["firstName", "lastName", "email", "phone", "city", "country", "subject", "message"].forEach((k) => {
      if (!v[k]?.trim()) e[k] = requiredMsg;
    });

    // email
    if (v.email && !emailRegex.test(v.email)) e.email = emailMsg;

    // phone: allow +, spaces, dashes; require 7–15 digits
    const digits = phoneDigits(v.phone).replace(/\D/g, "");
    if (v.phone && (digits.length < 7 || digits.length > 15)) e.phone = phoneMsg;

    // subject override message if empty
    if (!v.subject?.trim()) e.subject = subjectMsg;

    // optional: minimum message length
    if (v.message && v.message.trim().length < 10) {
      e.message = t("contactUs.validation.message_min", { defaultValue: "Message must be at least 10 characters." });
    }

    return e;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const next = { ...values, [name]: value };
    setValues(next);
    // live-validate touched fields
    if (touched[name]) setErrors(validate(next));
  };

  const handleBlur = (e) => {
    const { name } = e.target;
    setTouched((prev) => ({ ...prev, [name]: true }));
    setErrors(validate(values));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const eObj = validate(values);
    setErrors(eObj);
    setTouched({
      firstName: true, lastName: true, email: true, phone: true,
      city: true, country: true, subject: true, message: true
    });

    if (Object.keys(eObj).length > 0) return;

    try {
      setSubmitting(true);
      // TODO: replace with your API call
      // await api.post('/contact', values)
      await new Promise((r) => setTimeout(r, 600));
      setSubmitted(true);
      setValues(initialValues);
      setTouched({});
    } finally {
      setSubmitting(false);
    }
  };

  const isInvalid = (name) => touched[name] && !!errors[name];
  const isValid = (name) => touched[name] && !errors[name];

  return (
    <div className='contact-us pt-5'>
      <Container>
        <div className='form-section '>
          <Row>
            <Col md={7} sm={12}>
              <div>
                <div className="image-wrapper">
                  <img src={img2} alt="" className="stat-img circle" />
                  <img src={img1} alt="" className="stat-img centered" />
                  <h5 className='text-center'>{t("contactUs.form_prompt")}</h5>
                </div>
              </div>
            </Col>

            <Col md={5} sm={12}>
              {/* <div className='form-container'>
                  <div className='form-header'>
                    <p>{t("contactUs.title")}</p>
                  </div>

                  <div className='form-body'>
                    {submitted && (
                      <div className="alert alert-success" role="alert">
                        {t("contactUs.success", { defaultValue: "Thanks! Your message has been sent." })}
                      </div>
                    )}

                    <Form noValidate onSubmit={handleSubmit}>
                      <Row className="mb-3">
                        <Form.Group as={Col} md="6" controlId="firstName">
                          <Form.Label>{t("contactUs.firstName")}</Form.Label>
                          <Form.Control
                            required
                            name="firstName"
                            type="text"
                            value={values.firstName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={isInvalid("firstName")}
                            isValid={isValid("firstName")}
                            autoComplete="given-name"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.firstName}
                          </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group as={Col} md="6" controlId="lastName">
                          <Form.Label>{t("contactUs.lastName")}</Form.Label>
                          <Form.Control
                            required
                            name="lastName"
                            type="text"
                            value={values.lastName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={isInvalid("lastName")}
                            isValid={isValid("lastName")}
                            autoComplete="family-name"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.lastName}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Row>

                      <Row className="mb-3">
                        <Form.Group as={Col} md="12" controlId="email">
                          <Form.Label>{t("contactUs.email")}</Form.Label>
                          <Form.Control
                            required
                            name="email"
                            type="email"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={isInvalid("email")}
                            isValid={isValid("email")}
                            autoComplete="email"
                            inputMode="email"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.email || emailMsg}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Row>

                      <Row className="mb-3">
                        <Form.Group as={Col} md="12" controlId="phone">
                          <Form.Label>{t("contactUs.phone")}</Form.Label>
                          <Form.Control
                            required
                            name="phone"
                            type="tel"
                            placeholder="+2 010 123 4567"
                            value={values.phone}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={isInvalid("phone")}
                            isValid={isValid("phone")}
                            autoComplete="tel"
                            inputMode="tel"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.phone || phoneMsg}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Row>

                      <Row className="mb-3">
                        <Form.Group as={Col} md="6" controlId="city">
                          <Form.Label>{t("contactUs.city")}</Form.Label>
                          <Form.Control
                            required
                            name="city"
                            type="text"
                            value={values.city}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={isInvalid("city")}
                            isValid={isValid("city")}
                            autoComplete="address-level2"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.city}
                          </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group as={Col} md="6" controlId="country">
                          <Form.Label>{t("contactUs.country")}</Form.Label>
                          <Form.Control
                            required
                            name="country"
                            type="text"
                            value={values.country}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={isInvalid("country")}
                            isValid={isValid("country")}
                            autoComplete="country-name"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.country}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Row>

                      <Row className="mb-3">
                        <Form.Group as={Col} md="12" controlId="subject">
                          <Form.Label>{t("contactUs.subject")}</Form.Label>
                          <Form.Control
                            required
                            name="subject"
                            type="text"
                            value={values.subject}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={isInvalid("subject")}
                            isValid={isValid("subject")}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.subject || subjectMsg}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Row>

                      <Row className="mb-3">
                        <Form.Group as={Col} md="12" controlId="message">
                          <Form.Label>{t("contactUs.message")}</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={4}
                            name="message"
                            placeholder={t("contactUs.message_placeholder")}
                            value={values.message}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={isInvalid("message")}
                            isValid={isValid("message")}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Row>

                      <div className='submit-section d-flex justify-content-between align-items-start '>
                        <Button
                          type="submit"
                          className='mx-4'
                          disabled={submitting}
                        >
                          {submitting ? t("contactUs.sending", { defaultValue: "Sending..." }) : t("contactUs.send")}
                        </Button>
                    
                      </div>
                    </Form>
                  </div>
                </div> */}
              <Container className="text-center d-flex flex-column justify-content-center align-items-center h-100">
                <h2>{t("Course Application")}</h2>
                <p>{t("please_fill_form")}</p>

                <button
                  className="btn btn-success"
                  onClick={() =>
                    window.open(
                      "https://forms.zohopublic.com/almotahidaeducation1/form/CourseApplication/formperma/eBx0tn1OcB-GQukt2Ia47chNZA8pWKuvAEpX1f1VGrg",
                      "_blank"
                    )
                  }
                >
                  {t("open_form")}
                </button>
              </Container>

            </Col>
          </Row>
        </div>
      </Container>

      <div className='map-section pb-5'>
        <Container>
          <div className='map-header'>
            <h5 className='text-success mb-3'>{t("contactUs.address_heading")}</h5>
            <strong>{t("contactUs.country_name")}</strong>
            <p>{t("contactUs.address_details")}</p>
            <p><b>{t("contactUs.email")}</b> : info@kalemon.academy</p>
            <p><b>{t("contactUs.phone_label")}</b> : 00962799881980</p>
          </div>
          <h4 className='text-center mt-5'>{t("contactUs.network_note")}</h4>
          <div className='location-map mt-5'>
            {/* <img src={location} alt="map" /> */}
          </div>
        </Container>
      </div>
    </div>
  );
};

export default ContactUs;
